import { render } from "./SplashScreen.vue?vue&type=template&id=7e4c69d4"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=7e4c69d4&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script